module.exports = __webpack_public_path__ + "static/media/ranking_podium.ce9aa314.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ranking_podium.svg
// module id = 511
// module chunks = 0